import MainRoute from './routes/main';
import NewRoute from './routes/new';
import EditRoute from './routes/edit';

import {
    DefaultRouteHandler
} from '../../../../utils/router-utils';

export default {
    path: '/games',
    component: DefaultRouteHandler,
    routes: [
        NewRoute,
        EditRoute,
        MainRoute
    ]
};



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/index.js